import {TextField} from "@mui/material";
import * as React from "react";
import {useDispatch} from "react-redux";
import {navigateTo} from "../../../navigateTo";
import {AxiosWealthManagementApiImpl} from "../../api/AxiosWealthManagementApi";
import {prominentButtonStyle} from "../common/buttonStyles";
import {RaisedButton} from "../common/RaisedButton";
import {FormattedMessage} from "react-intl";
import {getTranslation} from "../../utils/translationUtil";
import {ApiError} from "../../model/ApiError.model";
import {setHeaderNotification} from "../base/header/HeaderActions";
import {NotificationTypes} from "../base/header/HeaderReducer";
import {FunctionComponent, useState} from "react";

export const DEFAULT_MESSAGE = "We are always interested in your feedback! Please use this form to send us a message regarding your experience.";

export const FeedbackPage: FunctionComponent = ()  => {
    const [invalidSubmission, setInvalidSubmission] = useState<boolean>(false);
    const [feedbackText, setFeedbackText] = useState<string>("");

    const dispatch = useDispatch();

    const getHelperText = () => {
            return invalidSubmission && !feedbackText.trim() ? "Required" : "";
        };

    const handleTextOnChange = (event: any) => {
        if(event.target.value.trim()) setInvalidSubmission(false);
        setFeedbackText(event.target.value);
    };

    const handleOnButtonClick = () => {
        if (feedbackText.trim()) {
            AxiosWealthManagementApiImpl.sendFeedback(feedbackText)
                .then(() => {
                    navigateTo("/feedback-success");
                })
                .catch((error: ApiError) => {
                    dispatch(setHeaderNotification({
                        message: error.message!,
                        notificationType: NotificationTypes.FAILURE,
                    }, 5000));
                });
        } else {
            setInvalidSubmission(true);
        }
    };

    return <div className="main-content feedback-container" data-testid="feedback-container">
        <h1>
            <FormattedMessage id={"feedback.header"} defaultMessage = "Feedback"/>
        </h1>
        <label>
            <p className="large">
                <FormattedMessage id={"feedback.paragraph"}
                                  defaultMessage={DEFAULT_MESSAGE}
                />
            </p>
        </label>
        <div className="text-field-container">
            <TextField id="feedback-textfield"
                       data-testid="feedback-textfield"
                       value={feedbackText}
                       name="text"
                       label={getTranslation("feedback.enter-feedback", "Enter feedback")}
                       color="primary"
                       className="feedback-text-input"
                       type="text"
                       autoFocus={true}
                       style={{fontSize: "15px", width: "100%"}}
                       multiline={true}
                       onChange={(event) => handleTextOnChange(event)}
                       error={invalidSubmission}
                       helperText={getHelperText()}
                       variant={'standard'}
            />
        </div>
        <RaisedButton
            className="feedback-page__send-button"
            style={prominentButtonStyle}
            primary={true}
            onClick={() => handleOnButtonClick()}>
            <FormattedMessage id="feedback.send" defaultMessage="Send" />
        </RaisedButton>
    </div>;
};